function openmenu() {
  document.querySelector(".mobile_menu").classList.toggle("open-mobile");
  document.querySelector(".mobile-menu").classList.toggle("open-menu");
}

function changemainimage(url) {
  document.querySelectorAll(".latest-thumbnail-image").forEach(function (img, index) {
    if (img.getAttribute("data-image") == url) {
      img.querySelector("img").click();
      var thumb1 = false,
        thumb2 = false,
        nav1 = false,
        nav2 = false;

      if (document.querySelector(".latest-thumbnail-images")) {
        thumb1 = true
      }

      if (document.querySelector(".latest-thumbnail-images-verticle")) {
        thumb2 = true
      }

      if (document.querySelector(".latest-main-image")) {
        nav1 = true
      }
      if (document.querySelector(".latest-main-image-vertical")) {
        nav2 = true
      }

      if (thumb1) {
        var latest_thumbnail_images = new Swiper(".latest-thumbnail-images", {
          spaceBetween: 24,
          autoHeight: true,
          slidesPerView: 4,
          speed: 300,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            0: {
              slidesPerView: 1.33,
              spaceBetween: 16,
            },
            750: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          },
        });
      }

      if (thumb2) {
        var latest_thumbnail_images2 = new Swiper(".latest-thumbnail-images-verticle", {
          direction: "vertical",
          spaceBetween: 16,
          slidesPerView: 4,
          freeMode: true,
          speed: 300,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            0: {
              slidesPerView: 5,
              spaceBetween: 16,
              direction: "horizontal",
            },
            750: {
              slidesPerView: 4,
              spaceBetween: 16,
              direction: "vertical",
            },
          },
        });
      }

      if (nav1) {
        var latest_main_thumbnail = new Swiper(".latest-main-image", {
          spaceBetween: 0,
          autoHeight: true,
          slidesPerView: 1,
          speed: 300,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: latest_thumbnail_images,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }

      if (nav2) {
        var latest_main_thumbnail2 = new Swiper(".latest-main-image-vertical", {
          spaceBetween: 0,
          autoHeight: true,
          slidesPerView: 1,
          speed: 300,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: latest_thumbnail_images2,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }

      if (index == 0) {
        if (thumb1) {
          latest_thumbnail_images.slideTo(1);
          latest_thumbnail_images.slideTo(0);
          latest_thumbnail_images.slideTo(-1);
        }

        if (nav1) {
          latest_main_thumbnail.slideTo(1);
          latest_main_thumbnail.slideTo(0);
          latest_main_thumbnail.slideTo(-1);
        }

        if (thumb2) {
          latest_main_thumbnail2.slideTo(1);
          latest_main_thumbnail2.slideTo(0);
          latest_main_thumbnail2.slideTo(-1);
        }

        if (nav2) {
          latest_thumbnail_images2.slideTo(1);
          latest_thumbnail_images2.slideTo(0);
          latest_thumbnail_images2.slideTo(-1);
        }
      }
      else {
        if (thumb1) {
          latest_thumbnail_images.slideTo(index);
        }

        if (nav1) {
          latest_main_thumbnail.slideTo(index);
        }

        if (thumb2) {
          latest_thumbnail_images2.slideTo(index);
        }

        if (nav2) {
          latest_main_thumbnail2.slideTo(index);
        }
      }

    }
  })
}

function changemasterproduct(newmaster, options, btn, price) {
  var master = newmaster.querySelectorAll("option");
  var selected = options.querySelectorAll(".latest-products-option.active");
  var variantname = '';

  for (let i = 0; i < selected.length; i++) {
    const element = selected[i].getAttribute("data-value");
    if (i == selected.length - 1) {
      variantname = variantname + element;
    }
    else {
      variantname = variantname + element + ' / ';
    }
  }

  var choosen = false;
  var available = false;
  var price = "";
  var id = "";

  for (let j = 0; j < master.length; j++) {
    const element = master[j].getAttribute("data-index");
    if (element == variantname) {
      id = master[j].getAttribute("value");
      newmaster.value = id;
      price = master[j].getAttribute("data-price");
      var choosen = true;
      available = master[j].getAttribute("data-available");
    }
  }

  var availabletext = newmaster.getAttribute("data-available-text");
  var soldouttext = newmaster.getAttribute("data-solout-text");
  var unavailabletext = newmaster.getAttribute("data-unavailable-text");
  price.textContent = price;

  if (choosen) {
    if (available == "true") {
      btn.textContent = availabletext;
      btn.removeAttribute("disabled");
    }
    else if (available == "false") {
      btn.textContent = soldouttext;
      btn.setAttribute("disabled");
    }
  }
  else {
    btn.textContent = unavailabletext;
    btn.setAttribute("disabled", "disabled")
  }
}

function changemaster() {
  var master = document.querySelectorAll("#masterselect option");

  var selected = document.querySelectorAll(".latest-main-product .latest-products-option.active");
  var variantname = '';

  for (let i = 0; i < selected.length; i++) {
    const element = selected[i].getAttribute("data-value");
    if (i == selected.length - 1) {
      variantname = variantname + element;
    }
    else {
      variantname = variantname + element + ' / ';
    }
  }

  var choosen = false;
  var available = false;
  var price = "";
  var compareatprice = "";
  var id = "";
  var save = "";

  for (let j = 0; j < master.length; j++) {
    const element = master[j].getAttribute("data-index");
    if (element == variantname) {
      id = master[j].getAttribute("value");
      document.querySelector("#masterselect").value = id;
      price = master[j].getAttribute("data-price");
      compareatprice = master[j].getAttribute("data-comapre-price");
      var choosen = true;
      available = master[j].getAttribute("data-available");
      document.querySelector("#show_pickup_availability").textContent = master[j].getAttribute("data-shop");
      save = master[j].getAttribute("data-save");
    }
  }
  console.log(variantname);
  var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
  var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
  var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");
  var savetext = document.querySelector("#masterselect").getAttribute("data-save");


  var nextURL = window.location.pathname + "?variant=" + id;
  window.history.replaceState("", "", nextURL);

  if (document.querySelector(".latest-add-to-cart-btn").classList.contains("updatelink")) {
    document.querySelector(".add_to_cart_price").textContent = price;
    if (compareatprice != "") {
      document.querySelector(".add_to_cart_compare").textContent = compareatprice;
    }
    if (save != "") {
      document.querySelector(".latest-add-to-cart-btn .btn_save").textContent = save;
    } else if (savetext != "") {
      document.querySelector(".latest-add-to-cart-btn .btn_save").textContent = savetext;
    }

    if (choosen) {
      if (available == "true") {
        document.querySelector(".latest-add-to-cart-btn .add_to_cart_text_change").textContent = availabletext;
        document.querySelector(".latest-add-to-cart-btn").removeAttribute("disabled");
      }
      else if (available == "false") {
        document.querySelector(".latest-add-to-cart-btn .add_to_cart_text_change").textContent = soldouttext;
        document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled");
      }
    }
    else {
      document.querySelector(".latest-add-to-cart-btn .add_to_cart_text_change").textContent = unavailabletext;
      document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled")
    }
  }
  else {
    if (choosen) {
      if (available == "true") {
        document.querySelector(".latest-add-to-cart-btn").textContent = availabletext + " - " + price;
        document.querySelector(".latest-add-to-cart-btn").removeAttribute("disabled");
      }
      else if (available == "false") {
        document.querySelector(".latest-add-to-cart-btn").textContent = soldouttext;
        document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled");
      }
    }
    else {
      document.querySelector(".latest-add-to-cart-btn").textContent = unavailabletext;
      document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled")
    }
  }
}


var latestslideshow = new Swiper(".latest-slideshow-container", {
  spaceBetween: 0,
  autoHeight: true,
  speed: 300,
  hashNavigation: {
    watchState: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var latestinstagram = new Swiper(".latest-instagram-container", {
  autoHeight: true,
  speed: 300,
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 32,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});


var slider_img_texts = new Swiper(".slider-img-texts", {
  spaceBetween: 35,
  grabCursor: true,
  a11y: false,
  speed: 7000,
  loop: true,
  slidesPerView: "auto",
  autoplay: {
    delay: 0.5,
    disableOnInteraction: false,
  },
})

var reivews_sections = new Swiper(".reivews-sections", {
  slidesPerView: 3,
  spaceBetween: 24,
  autoHeight: true,
  speed: 300,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


var latest_thumbnail_images = new Swiper(".latest-thumbnail-images", {
  spaceBetween: 24,
  autoHeight: true,
  slidesPerView: 4,
  speed: 300,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.33,
      spaceBetween: 16,
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});

var latest_thumbnail_images2 = new Swiper(".latest-thumbnail-images-verticle", {
  direction: "vertical",
  slidesPerView: 4,
  spaceBetween: 16,
  freeMode: true,
  speed: 300,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 5,
      spaceBetween: 16,
      direction: "horizontal",
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 16,
      direction: "vertical",
    },
  },
});


var latest_main_thumbnail = new Swiper(".latest-main-image", {
  spaceBetween: 0,
  autoHeight: true,
  slidesPerView: 1,
  speed: 300,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: latest_thumbnail_images,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

var latest_main_thumbnail2 = new Swiper(".latest-main-image-vertical", {
  spaceBetween: 0,
  autoHeight: true,
  slidesPerView: 1,
  speed: 300,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: latest_thumbnail_images2,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

var slider_review_custom = new Swiper(".slider-custom-reviews", {
  spaceBetween: 20,
  slidesPerView: 1.2,
  speed: 300,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

window.onload = function () {
  document.querySelectorAll(".slider-custom-reviews .swiper-wrapper").forEach(function (swipe) {
    var swipeheight = swipe.scrollHeight;
    swipe.querySelectorAll(".swiper-slide .review-image-block-review").forEach(function (slide) {
      slide.style.height = swipeheight + 'px';
    })
  })
}

document.querySelectorAll(".hasmenu").forEach(function (link) {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    this.nextElementSibling.classList.toggle("hide");
    this.querySelector(".menu-arrows").classList.toggle("rotate-180");
  });
});

if (document.querySelector("#close_anouncement_bar")) {
  document.querySelector("#close_anouncement_bar").addEventListener("click", function () {
    this.parentElement.parentElement.style.display = "none";
  });
}

document.querySelectorAll(".latest-products-option").forEach(function (option) {
  option.addEventListener("click", function (e) {
    e.preventDefault();
    var variant_image = this.getAttribute("data-image");
    if (variant_image) {
      changemainimage(variant_image)
    }

    this.parentElement.querySelector(".active").classList.remove("active");
    this.classList.add("active");
    if (!this.classList.contains("notproduct")) {
      changemaster();
    }
    else {
      var master = this.parentElement.parentElement.nextElementSibling.querySelector(".masterselectproduct");
      var options = this.parentElement.parentElement;
      var btn = this.parentElement.parentElement.nextElementSibling.querySelector("button");
      var price = this.parentElement.parentElement.nextElementSibling.nextElementSibling;
      var image = this.previousElementSibling.innerHTML;
      this.parentElement.parentElement.parentElement.querySelector(".latest-product-item-first-image").innerHTML = image;
      changemasterproduct(master, options, btn, price);
    }
  });
});

function opentabs(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

if (document.getElementById("defaultOpen") != null) {
  document.getElementById("defaultOpen").click();
}


// document.querySelectorAll(".latest-thumbnail-image img").forEach(function(img){
//   img.addEventListener("click", function(){
//     var src = this.getAttribute("src");
//     var datasrcset = this.getAttribute("data-srcset");
//     var srcset = this.getAttribute("srcset")
//     document.querySelector(".latest-main-image img").setAttribute("src", src);
//     document.querySelector(".latest-main-image img").setAttribute("data-srcset", datasrcset);
//     document.querySelector(".latest-main-image img").setAttribute("srcset", srcset);
//   });
// });

document.querySelectorAll(".colordropdown").forEach(function (select) {
  select.addEventListener("change", function () {
    var val = this.value;
    var options = this.parentElement.nextElementSibling.querySelectorAll(".latest-products-option");
    console.log(options);
    for (let i = 0; i < options.length; i++) {
      const element = options[i].getAttribute("data-value");
      if (element == val) {
        options[i].click();
      }
    }
  });
});

if (document.querySelector("#opensizechart") != null) {
  document.querySelector("#opensizechart").addEventListener("click", function () {
    document.querySelector(".latest-product-chart").classList.add("openchart");
    document.querySelector(".size-overlay").classList.add("openchart");
  });

  document.querySelector(".size-close").addEventListener("click", function () {
    document.querySelector(".latest-product-chart").classList.remove("openchart");
    document.querySelector(".size-overlay").classList.remove("openchart");
  })
}

if (document.querySelector(".feeback-form button")) {
  document.querySelector(".feeback-form button").addEventListener("click", function (e) {
    var loop = 0;
    document.querySelectorAll(".input-section input").forEach(function (input) {
      if (input.value == "") {
        input.parentElement.classList.add("error-messages");
        loop = 1;
      }
      else {
        input.parentElement.classList.remove("error-messages");
      }
    });

    if (loop > 0) {
      e.preventDefault();
    }
  })
}

if (document.querySelector(".product-form-latest")) {
  window.onscroll = function () {
    if (window.scrollY > 767 && screen.width < 750) {
      document.querySelector(".product-form-latest").classList.add("sticky_btn");
    }
    else {
      document.querySelector(".product-form-latest").classList.remove("sticky_btn");
    }
  }
}

// document.querySelectorAll(".latest-products-option.active").forEach(function(option){
//   option.click();
// });


document.querySelectorAll(".main-product-image-index").forEach(function (image, index) {
  image.addEventListener("click", function () {
    document.querySelector(".product-popup-image").classList.add("openpopup");
    document.querySelectorAll(".popup-image-container .popup-image")[index].scrollIntoView();
  });

  document.querySelector("#product-popup-close").addEventListener("click", function () {
    document.querySelector(".product-popup-image").classList.remove("openpopup");
  });
});

document.querySelectorAll(".popup-image-container .popup-image").forEach(function (img) {
  img.addEventListener("click", function () {
    document.querySelector(".product-popup-image").classList.remove("openpopup");
  });
});


// popup--js

$ = function (id) {
  return document.getElementById(id);
}

var show = function (id) {
  $(id).style.display = 'block';
}
var hide = function (id) {
  $(id).style.display = 'none';
}


// timer js

// var timer;
// function settimer(){
//  currentTime = new Date();
//  clearInterval(timer); 
//  var timer_day=24;
//  var timer_year=currentTime.getFullYear()+1;
//  var timer_hour=00;
//  if(timer_hour=="")timer_hour=0;
//  var timer_min=00;
//  if(timer_min=="")timer_min=0;

//  var timer_date=timer_month+"/"+timer_day+"/"+timer_hour+":"+timer_min;
//  var end = new Date(timer_date); // Arrange values in Date Time Format
//  var now = new Date(); // Get Current date time
//  var second = 1000; // Total Millisecond In One Sec
//  var minute = second * 60; // Total Sec In One Min
//  var hour = minute * 60; // Total Min In One Hour
//  var day = hour * 24; // Total Hour In One Day

// function showtimer() {
//   var now = new Date();
//   var remain = end - now; // Get The Difference Between Current and entered date time
//   if(remain < 0){
//     clearInterval(timer);
//     //document.getElementById("timer_value").innerHTML = 'Reached!';
//     return;
//   }
//   var days = Math.floor(remain / day); // Get Remaining Days
//   var hours = Math.floor((remain % day) / hour); // Get Remaining Hours
//   var minutes = Math.floor((remain % hour) / minute); // Get Remaining Min
//   var seconds = Math.floor((remain % minute) / second); // Get Remaining Sec
//   document.getElementById("timerdays").innerHTML = days;
//   document.getElementById("timerHours").innerHTML = hours;
//   document.getElementById("timerMinutes").innerHTML = minutes;
//   document.getElementById("timerSeconds").innerHTML = seconds;
// }
//   timer = setInterval(showtimer, 1000); // Display Timer In Every 1 Sec
// }

// if (document.getElementById("timerHours")) {
//   settimer();  
// }

if (document.querySelector(".pagination")) {
  if (document.querySelector(".pagination .next")) {
    document.querySelector(".pagination .next a").innerHTML = "Next &nbsp;>"
  }

  if (document.querySelector(".pagination .prev")) {
    document.querySelector(".pagination .prev a").innerHTML = "<&nbsp; Previous"
  }
}
if (document.querySelector("#contestbutton")) {
  document.querySelector("#contestbutton").addEventListener("click", function () {
    var list = "XNZSCJ";
    // grab fields; 
    var inputemail = document.querySelector("#contestemail");
    var inputanswer = document.querySelector("#contestanswer");
    var inputnumber = document.querySelector("#contestnumber");
    var inputname = document.querySelector("#contestname");
    var email = inputemail.value;
    var answer = inputanswer.value;
    var name = inputname.value;
    var number = inputnumber.value;

    if (answer == "") {
      inputanswer.classList.add("error");
      return;
    }
    else {
      inputanswer.classList.remove("error");
    }

    if (name == "") {
      inputname.classList.add("error");
      return;
    }
    else {
      inputname.classList.remove("error");
    }

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
      inputemail.classList.add("error");
      return;
    }
    else {
      inputemail.classList.remove("error");
    }

    if (number == "" && number.length < 5) {
      inputnumber.classList.add("error");
      return;
    }
    else {
      inputnumber.classList.remove("error");
    }

    // $(this).find("span").addClass("hidden");
    // $(this).find(".loading-overlay__spinner").removeClass("hidden");

    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": list,
        "email": email,
        // pass in additional fields 
        "$fields": "$source, $answer, $fullname, $phonenumber",
        "$source": "Weekly Giveaway",
        "$answer": answer,
        "$fullname": name,
        "$phonenumber": number
      }
    };
    jQuery.post(settings).done(function (response) {
      console.log(response);
      console.log(response);
      // select and submit form after subscribing 
      // $(id).submit(); 
      // 

      document.querySelector(".Poupu-content-box .form-elements").classList.add("hide");
      document.querySelector(".Poupu-content-box").classList.add("form-submitted")
      document.querySelector(".contestthankyou").classList.remove("hide");
    })
  });
}

document.querySelectorAll(".grid_change").forEach(function (grid) {
  grid.addEventListener("click", function () {
    this.parentElement.querySelector(".grid_active").classList.remove("grid_active");
    this.classList.add("grid_active");
    if (this.classList.contains('grid_1')) {
      document.querySelectorAll(".collection-product-item").forEach(function (prod) {
        prod.classList.remove("w-50-g-24-m");
        prod.classList.add("w-100-m");
      });
    }
    else {
      document.querySelectorAll(".collection-product-item").forEach(function (prod) {
        prod.classList.add("w-50-g-24-m");
        prod.classList.remove("w-100-m");
      });
    }
  });
});

if (document.querySelector(".open-filters")) {
  document.querySelector(".open-filters").addEventListener("click", function () {
    document.querySelector(".mobile_sort_filters").classList.toggle("hide");
  });

  document.querySelectorAll(".mobile_sort_filters ul li").forEach(function (filter, index) {
    filter.addEventListener("click", function (e) {
      e.preventDefault();
      this.parentElement.querySelectorAll("input").forEach(function (input) {
        input.removeAttribute("checked");
      });

      this.querySelector("input").setAttribute("checked", "checked");
      document.querySelectorAll(".cc-filter--sort li label")[index].click();



      var results = setInterval(() => {
        if (!document.querySelector(".cc-filters-results").classList.contains("is-loading")) {
          clearInterval(results);
          if (document.querySelector(".grid_active").classList.contains('grid_1')) {
            document.querySelectorAll(".collection-product-item").forEach(function (prod) {
              prod.classList.remove("w-50-g-24-m");
              prod.classList.add("w-100-m");
            });
          }
          else {
            document.querySelectorAll(".collection-product-item").forEach(function (prod) {
              prod.classList.add("w-50-g-24-m");
              prod.classList.remove("w-100-m");
            });
          }
        }
      }, 500);
    });
  });
}

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.classList.remove("panel-1");
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.classList.add("panel-1");
    }
  });
}

function changeprevious(btn, prvbtn, nextbtn, btnn) {
  document.querySelector(prvbtn).click();
  var attr = document.querySelector(prvbtn).getAttribute("aria-disabled");
  var diffbtn = document.querySelector(nextbtn).getAttribute("aria-disabled");
  if (attr == 'true') {
    btn.classList.add("hide_btn");
  } else {
    btn.classList.remove("hide_btn");
  }

  if (diffbtn == 'true') {
    document.querySelector(btnn).classList.add("hide_btn");
  } else {
    document.querySelector(btnn).classList.remove("hide_btn");
  }
}

function changenext(btn, nextbtn, prvbtn, btnp) {
  document.querySelector(nextbtn).click();
  var attr = document.querySelector(nextbtn).getAttribute("aria-disabled");
  var diffbtn = document.querySelector(prvbtn).getAttribute("aria-disabled");
  if (attr == 'true') {
    btn.classList.add("hide_btn");
  } else {
    btn.classList.remove("hide_btn");
  }

  if (diffbtn == 'true') {
    document.querySelector(btnp).classList.add("hide_btn");
  } else {
    document.querySelector(btnp).classList.remove("hide_btn");
  }

}

if (document.querySelector(".latest-stikcy-btn")) {
  window.onscroll = function () {
    // console.log(window.scrollY)
    if (window.scrollY > 1000) {
      document.querySelector(".latest-stikcy-btn").classList.add("show_sticky");
    } else {
      document.querySelector(".latest-stikcy-btn").classList.remove("show_sticky");
    }
  }
}

function updatecart() {
  fetch('/?sections=header-new')
    .then(response => response.text())
    .then(data => {
      let cardSliderJson = JSON.parse(data);
      let cardSlider = new DOMParser();
      console.log(cardSliderJson);
      let doc = cardSlider.parseFromString(cardSliderJson["header-new"], "text/html");
      document.querySelector('.cart_count').innerHTML = doc.querySelector(".cart_count").innerHTML;
    });
}

function updateaddtocart() {
  fetch('/?sections=latest-main-product-new')
    .then(response => response.text())
    .then(data => {
      let cardSliderJson = JSON.parse(data);
      let cardSlider = new DOMParser();

      let doc = cardSlider.parseFromString(cardSliderJson["latest-main-product-new"], "text/html");
      console.log(doc)
      document.querySelector(".updatelink")
        ? document.querySelector(".updatelink").innerHTML = doc.querySelector(".updatelink").innerHTML
        : "";
    });
}

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\//.test(entry.name);
      if (isValidRequestType && isCartChangeRequest) {
        updatecart()
      }
    });
  });
  cartObserver.observe({ entryTypes: ["resource"] });
}

observeCartChanges()

if (document.querySelector(".latest-product-reviews-container") && screen.width > 749) {
  var reivewheight = (document.querySelector(".latest-product-reviews-container").scrollHeight - 60) / 2;
  document.querySelectorAll(".review-image-block").forEach(function (review) {
    review.querySelector(".rimage-wrapper").style.height = reivewheight + 'px';
  })
}

if (document.querySelector(".videosSwiper")) {
  document.querySelectorAll(".videosSwiper").forEach(function (video) {
    var videoheight = video.scrollHeight;
    video.querySelectorAll(".videoSlide").forEach(function (videoslide) {
      videoslide.style.height = videoheight + 'px';
    })
  })

}